// Single source of truth for all artist data
// These are fictional artist names created for the game
// Color schemes match the ORIGINAL baseline colors from engine/constants.ts

export const ARTISTS = {
  SOLSTICE_VANE: {
    name: 'Solstice Vane',
    slug: 'solstice_vane',
    cardCount: 12,
    colorScheme: {
      primary: '#F5C846', // Original yellow/gold
      secondary: '#fbbf24',
      accent: '#fcd34d',
    },
  },
  MIRA_FAUX: {
    name: 'Mira Faux',
    slug: 'mira_faux',
    cardCount: 13,
    colorScheme: {
      primary: '#2DD4BF', // Original teal
      secondary: '#14b8a6',
      accent: '#5eead4',
    },
  },
  ATLAS_ZERO: {
    name: 'Atlas Zero',
    slug: 'atlas_zero',
    cardCount: 14,
    colorScheme: {
      primary: '#DC2626', // Original red
      secondary: '#b91c1c',
      accent: '#f87171',
    },
  },
  VESPER_KINT: {
    name: 'Vesper Kint',
    slug: 'vesper_kint',
    cardCount: 15,
    colorScheme: {
      primary: '#22C55E', // Original green
      secondary: '#16a34a',
      accent: '#4ade80',
    },
  },
  LUXE_NEBULA: {
    name: 'Luxe Nebula',
    slug: 'luxe_nebula',
    cardCount: 16,
    colorScheme: {
      primary: '#A855F7', // Original purple
      secondary: '#9333ea',
      accent: '#c084fc',
    },
  },
} as const

// Type for artist slugs
export type ArtistSlug = typeof ARTISTS[keyof typeof ARTISTS]['slug']

// Array of all artist slugs (sorted by card count ascending, matching original distribution)
export const ALL_ARTIST_SLUGS: ArtistSlug[] = [
  ARTISTS.SOLSTICE_VANE.slug,
  ARTISTS.MIRA_FAUX.slug,
  ARTISTS.ATLAS_ZERO.slug,
  ARTISTS.VESPER_KINT.slug,
  ARTISTS.LUXE_NEBULA.slug,
]

// Get artist by slug
export function getArtistBySlug(slug: string) {
  return Object.values(ARTISTS).find((artist) => artist.slug === slug)
}

// Get artist color scheme by slug
export function getArtistColorScheme(slug: string) {
  return getArtistBySlug(slug)?.colorScheme
}

// Legacy compatibility - old artist name to new artist slug mapping
// This helps identify files that still need updating
export const LEGACY_ARTIST_MAPPING = {
  'Solstice Vane': ARTISTS.SOLSTICE_VANE.slug,
  'Mira Faux': ARTISTS.MIRA_FAUX.slug,
  'Atlas Zero': ARTISTS.ATLAS_ZERO.slug,
  'Vesper Kint': ARTISTS.VESPER_KINT.slug,
  'Luxe Nebula': ARTISTS.LUXE_NEBULA.slug,
} as const
